module.exports = __webpack_public_path__ + "media/images/front/qrs/LOGO-EL-LA-2b02ee35e707e24a54edeef1f77a3ddf.jpg";